var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBandcamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#639AA9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3038_22768)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.547 22.875c-1.752 0-2.648 1.304-2.648 3.268 0 1.857.969 3.25 2.648 3.25 1.9 0 2.612-1.643 2.612-3.25-.002-1.678-.896-3.268-2.612-3.268zM25.891 18h2.081v4.714h.037c.566-.893 1.753-1.447 2.812-1.447 2.976 0 4.42 2.216 4.42 4.912 0 2.482-1.279 4.821-4.073 4.821-1.278 0-2.648-.303-3.269-1.518h-.036v1.269h-1.972V18zM42.918 24.608c-.165-1.126-1.005-1.733-2.155-1.733-1.078 0-2.593.554-2.593 3.357 0 1.536.693 3.162 2.501 3.162 1.205 0 2.045-.787 2.247-2.109h2.081C44.615 29.678 43.1 31 40.671 31c-2.958 0-4.583-2.053-4.583-4.768 0-2.785 1.552-4.964 4.657-4.964 2.19 0 4.054 1.071 4.254 3.34h-2.081z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.613 30.723H3L10.291 18h15.614l-7.292 12.723z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3038_22768"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 18)",
    d: "M0 0h42v13H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandcamp);
export default __webpack_public_path__ + "static/media/bandcamp.a7959f65354622b7bbc561bb599c7d1d.svg";
export { ForwardRef as ReactComponent };